import qc from 'keys/queryClient'
import React, { useMemo, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { ProfilesPageStyles } from './Style'
import { getStudentBatteriesProfilesFetch } from 'store/middlewares/assessment.crud'
import { useSelector } from 'react-redux'
import RatingList from './RatingList'
import FilterManager from 'components/FilterManager'

export const ProfilesContext = React.createContext()

const ProfilePage = (props) => {
    const { showDetails, setVisibleRatings, visibleRatings, setFilters, filters, title, subTitle, customToolbar } = props

    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)

    const [totalFluencyCount, setTotalFluencyCount] = useState(0)

    const profiles = useQuery({
        queryKey: [qc.profiles, "student_batteries", headerFilters, filters, testTaker],
        queryFn: async () => {
            const { data } = await getStudentBatteriesProfilesFetch({ assessmentFilters: filters, headerFilters, testTaker, })

            const totalFluencyCount = Object.values(data).reduce(
                (sum, item) => sum + (item.FLUENCY?.count ?? 0),
                0
            )

            setTotalFluencyCount(totalFluencyCount)

            return data
        }
    })

    const filterSchema = {
        primary: [
            { key: "semester", overrides: { hideClear: true } },
            { key: "school_year", overrides: { hideClear: true } }
        ]
    }

    const commonState = useMemo(() => ({
        profiles,
        visibleRatings, setVisibleRatings,
        showDetails,
        totalFluencyCount
    }), [profiles, visibleRatings, showDetails])

    return (
        <ProfilesPageStyles>
            <ProfilesContext.Provider value={commonState}>
                <div className='description-header'>
                    <div className='bold'>{title}</div>
                    <div>{subTitle(totalFluencyCount)}</div>
                </div>
                <div className='wrap-profiles-content'>
                    <div className='profiles-header'>
                        <FilterManager
                            // wrapperRef={wrapperRef}
                            schema={filterSchema}
                            values={filters}
                            onChange={setFilters}
                            customToolbar={customToolbar}
                        />
                    </div>
                    <div className='profiles-content'>
                        {props.children}
                        <RatingList />
                    </div>
                </div>
            </ProfilesContext.Provider>
        </ProfilesPageStyles>
    )
}

export default ProfilePage